import { APIRequest } from './api-service/api-request';

export const getGeocodeRequest = (params: google.maps.GeocoderRequest): Promise<any> => {
  const request = new APIRequest();
  return request.post(`${process.env.GEOCODING_CF_URL}/latlng`, { lat: params.location?.lat, lng: params.location?.lng });
};
